import { Card, Drawer, Icon, Button, notification, Alert } from "antd";
import React from "react";
import { TableComp } from "sz-react-utils";
import Request, { MEDIA_URL } from "../../request";
import moment from "moment";
const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
const dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY';
const companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';
class UpdateInvoiceStatusRequest extends React.Component {
    state = {
        visible: true,
        count: 0,
        loading: false,
    }

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            this.props.onClose();
        }, 50)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let response = await Request.getInvoiceStatusUpdateRequests();
            this.setState({ count: response.total });
            return resolve(response);
        })
    }

    handleInvoiceAction = async (invoiceId, status) => {
        let disapproveReason = null;
        if (status === "Disapprove") {
            disapproveReason = prompt('Reason of Disapproval');
        }
        if (status === "Disapprove" && !disapproveReason) {
            notification.error({
                message: 'Add Reason For Disapprove'
            });
            return
        }

        let data = { _id: invoiceId, status, disapproveReason };
        this.setState({ loading: true });
        let response = await Request.updateInvoiceUpdateRequest(data);
        this.setState({ loading: false });
        if (response.success) {
            notification.success({
                message: response.message
            });
        } else {
            notification.error({
                message: response.message
            });
        }
        this.table.current.reload();
    }

    render() {
        let { visible, count, loading } = this.state;
        const currencySymbols = {
            USD: "$",      // US Dollar
            EUR: "€",      // Euro
            GBP: "£",      // British Pound
            INR: "₹",      // Indian Rupee
            AUD: "A$",     // Australian Dollar
            CAD: "C$",     // Canadian Dollar
            JPY: "¥",      // Japanese Yen
            CNY: "¥",      // Chinese Yuan
            NZD: "NZ$",    // New Zealand Dollar
            CHF: "CHF",    // Swiss Franc
            SGD: "S$",     // Singapore Dollar
            HKD: "HK$",    // Hong Kong Dollar
            SEK: "kr",     // Swedish Krona
            NOK: "kr",     // Norwegian Krone
            DKK: "kr",     // Danish Krone
            ZAR: "R",      // South African Rand
            AED: "د.إ",    // UAE Dirham
            SAR: "﷼",     // Saudi Riyal
            THB: "฿",      // Thai Baht
            MYR: "RM",     // Malaysian Ringgit
            IDR: "Rp",     // Indonesian Rupiah
            KRW: "₩",      // South Korean Won
            TRY: "₺",      // Turkish Lira
            RUB: "₽",      // Russian Ruble
            BRL: "R$",     // Brazilian Real
            MXN: "$",      // Mexican Peso
            PHP: "₱",      // Philippine Peso
            PLN: "zł",     // Polish Zloty
            HUF: "Ft",     // Hungarian Forint
            CZK: "Kč",     // Czech Koruna
        };
        const columns = [
            {
                title: 'Actions',
                key: 'actions',
                width: 80,
                align: 'center',
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                            <Button
                                loading={loading}
                                type="primary"
                                size="small"
                                icon="check"
                                shape="circle"
                                style={{ background: '#52c41a', borderColor: '#52c41a', fontSize: '12px' }}
                                onClick={() => this.handleInvoiceAction(record._id, 'Approve')}
                                title="Approve"
                            />
                            <Button
                                loading={loading}
                                type="danger"
                                size="small"
                                icon="close"
                                shape="circle"
                                style={{ fontSize: '12px' }}
                                onClick={() => this.handleInvoiceAction(record._id, 'Disapprove')}
                                title="Disapprove"
                            />
                        </div>
                    );
                }
            },
            {
                title: '#',
                key: 'serialNumber',
                width: 50,
                align: 'center',
                render: (text, record, index) => (
                    <span style={{ fontWeight: 600, color: '#8c8c8c' }}>{index + 1}</span>
                )
            },
            {
                title: 'Invoice Details',
                key: 'invoiceDetails',
                width: 280,
                render: (text, record) => {
                    var invNum = record && record.invoiceNumber ? record.invoiceNumber : '-';
                    var invType = record && record.invoiceType ? record.invoiceType : '-';
                    var invStatus = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
                    var approvalStatus = record && record.invoiceApprovalStatus ? record.invoiceApprovalStatus : '-';
                    var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

                    var invoiceCurrency =
                        record &&
                            record.invoices &&
                            record.invoices.length > 0 &&
                            record.invoices[0].currency
                            ? record.invoices[0].currency
                            : 'EUR';
                    var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';

                    var createdUser = record && record.createdByUser ? record.createdByUser : null;
                    var createdByName = createdUser && createdUser.name ? createdUser.name : '-';

                    var invDate = record && record.invoiceGeneratedDate ? record.invoiceGeneratedDate : null;
                    var formattedGenDate = '-';
                    if (invDate) {
                        var rawGenDate = invDate.$date ? invDate.$date : invDate;
                        formattedGenDate = moment(rawGenDate).format('DD.MM.YYYY');
                    }

                    var getStatusColors = function (currentStatus) {
                        var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#d48806', bg: '#fffbe6', border: '#ffe58f' },
                            'CLEARED': { color: '#237804', bg: '#f6ffed', border: '#95de64' },
                            'APPROVED': { color: '#389e0d', bg: '#f6ffed', border: '#b7eb8f' },
                            'PAID BY UNI': { color: '#531dab', bg: '#f9f0ff', border: '#d3adf7' },
                            'SUBMITTED TO UNI': { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' }
                        };
                        return config[s] || { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' };
                    };

                    var mainStatusStyles = getStatusColors(invStatus);
                    var approvalStyles = getStatusColors(approvalStatus);

                    var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;
                    var receipts = record && record.paymentReceipt ? record.paymentReceipt : [];
                    var singleReceiptUrl = receipts.length > 0 && receipts[0].url ? receipts[0].url : null;

                    return (
                        <div style={{
                            padding: '12px 14px',
                            background: '#fff',
                            borderRadius: '10px',
                            border: '1px solid #f0f0f0',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.04)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontWeight: 700, fontSize: '13px' }}>
                                    {invUrl ? (
                                        <a
                                            href={`${MEDIA_URL}${invUrl}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#096dd9', borderBottom: '1px dashed #096dd9', textDecoration: 'none' }}
                                        >
                                            Inv#: {invNum}
                                        </a>
                                    ) : (
                                        "Inv#: " + invNum
                                    )}
                                </span>
                                <div style={{
                                    fontSize: '11px',
                                    color: '#595959',
                                    background: '#f5f5f5',
                                    padding: '3px 8px',
                                    borderRadius: '4px',
                                    border: '1px solid #e8e8e8'
                                }}>
                                    <Icon type="calendar" style={{ marginRight: 5, color: '#8c8c8c' }} />
                                    {formattedGenDate}
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                                <div>
                                    <div style={{ fontSize: '16px', fontWeight: 800, color: '#141414', lineHeight: 1.2 }}>
                                        {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
                                    </div>
                                    <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
                                        Type: <strong style={{ color: '#595959' }}>{invType}</strong>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
                                    <span style={{
                                        fontSize: '10px',
                                        fontWeight: 700,
                                        color: mainStatusStyles.color,
                                        background: mainStatusStyles.bg,
                                        border: '1px solid ' + mainStatusStyles.border,
                                        padding: '1px 8px',
                                        borderRadius: '12px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px'
                                    }}>
                                        {invStatus}
                                    </span>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginTop: '2px', fontSize: '11px', borderTop: '1px solid #f5f5f5', paddingTop: '6px' }}>
                                {invUrl && (
                                    <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#13c2c2' }}>
                                        <Icon type="file-pdf" style={{ marginRight: 2 }} /> Invoice File
                                    </a>
                                )}
                                {singleReceiptUrl && (
                                    <a href={`${MEDIA_URL}${singleReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#722ed1' }}>
                                        <Icon type="file-done" style={{ marginRight: 2 }} /> Receipt
                                    </a>
                                )}
                            </div>

                            <div style={{
                                marginTop: '2px',
                                fontSize: '11px',
                                color: '#8c8c8c'
                            }}>
                                <Icon type="user" style={{ marginRight: 4, color: '#bfbfbf' }} />
                                By: <span style={{ color: '#595959', fontWeight: 500 }}>{createdByName}</span>
                            </div>
                        </div>
                    );
                }
            },
            {
                title: 'Student & Course Details',
                key: 'studentCourseDetails',
                width: 340,
                render: (text, record) => {

                    var students = record && record.invoices ? record.invoices : [];

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {students.map((student, idx) => {
                                console.log(student);
                                var studentConversion = student.conversionRate ? student.conversionRate : '-';
                                var studentCurrency = student.currency ? student.currency : 'EUR';
                                var sym = currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';
                                var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                                var itemComm = student.commissionTotal ? Number(student.commissionTotal) : 0;
                                var itemGrossConverted = student.grossPaymentReceived ? Number(student.grossPaymentReceived) : 0;

                                // Safe backend term numbers data access parsing
                                var currentTerm = student.termNumber ? student.termNumber : '1';
                                var totalTerms = student.inquiry && student.inquiry.totalTerms ? student.inquiry.totalTerms : '1';

                                // ✅ Fetching student branch name cleanly from loop object
                                var branchName = student.studentBranchName ? student.studentBranchName : '-';

                                return (
                                    <div key={idx} style={{
                                        padding: '10px',
                                        background: '#fafafa',
                                        borderRadius: '8px',
                                        border: '1px solid #f0f0f0',
                                        borderBottom: idx !== students.length - 1 ? '1px dashed #d9d9d9' : '1px solid #f0f0f0',
                                        lineHeight: '22px'
                                    }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <a
                                                href={`/desk/getClaim?id=${student.studentId}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ fontWeight: 700, color: '#1677ff', fontSize: '14px', textDecoration: 'none' }}
                                            >
                                                <Icon type="user" style={{ marginRight: 6 }} />
                                                {student.studentName}
                                            </a>

                                            {/* Term Badge integrated precisely inside the inner loop structure */}
                                            <span style={{
                                                fontSize: '11px',
                                                fontWeight: 700,
                                                color: '#096dd9',
                                                background: '#e6f7ff',
                                                border: '1px solid #91d5ff',
                                                padding: '1px 6px',
                                                borderRadius: '4px'
                                            }}>
                                                T{currentTerm} / T{totalTerms}
                                            </span>
                                        </div>

                                        <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                            <b>VID:</b> {student.studentVisionId} | <b>Passport:</b> {student.passportNumber}
                                        </div>

                                        {/* ✅ Added: Student Branch Name Tag Line below VID meta */}
                                        <div style={{ fontSize: '11px', color: '#595959', fontWeight: 500 }}>
                                            <Icon type="environment" style={{ marginRight: 6, color: '#ff4d4f' }} />
                                            Branch: <strong style={{ color: '#262626' }}>{branchName}</strong>
                                        </div>

                                        <div style={{ fontWeight: 600, color: '#262626', marginTop: '4px' }}>
                                            <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
                                            {student.universityInstitutionName || '-'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#595959', fontStyle: 'italic' }}>
                                            {student.courseName}
                                        </div>

                                        <div style={{
                                            marginTop: '6px',
                                            paddingTop: '4px',
                                            borderTop: '1px dashed #e8e8e8',
                                            fontSize: '11px',
                                            color: '#434343',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '2px'
                                        }}>
                                            <div><b>Tuition Fee:</b> {sym}{Number(student.tutionFee || 0).toFixed(2)}</div>
                                            {/* Pre-calculated amounts displayed directly without multi-conversion bugs */}
                                            <div><b>Commission:</b> {sym}{itemComm.toFixed(2)}</div>
                                            <div><b>Gross Received:</b> {companySymbol}{itemGrossConverted.toFixed(2)}</div>

                                            <div style={{ color: '#8c8c8c', fontSize: '10px', marginTop: '2px' }}>
                                                <Icon type="swap" style={{ marginRight: 4 }} />
                                                Ex Rate: 1 {studentCurrency} = {studentConversion} INR
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                title: 'Financial Breakdown',
                key: 'financialBreakdown',
                width: 240,
                render: (text, record) => {
                    var invoiceCurrency = record && record.invoices && record.invoices.length > 0 && record.invoices[0].currency ? record.invoices[0].currency : 'EUR';
                    var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';
                    var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

                    var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

                    // Net Credited/Received Amount (INR) - Database value is already after TDS deduction
                    var netReceivedINR = 0;
                    if (record && record.invoices) {
                        netReceivedINR = record.invoices.reduce((sum, item) => {
                            return sum + (Number(item.grossPaymentReceived) || 0);
                        }, 0);
                    }

                    // Additional Deductions / TDS Amount (INR) - stored as negative value like -984.11
                    var additionalTaxTotal = 0;
                    if (record && record.additionalTaxDetails && record.additionalDeduction) {
                        additionalTaxTotal = record.additionalTaxDetails.reduce((sum, item) => {
                            return sum + Number(item.totalTax || 0);
                        }, 0);
                    }

                    var bankChargesTotal = Number(record && record.bankCharges ? record.bankCharges : 0);

                    // Original Invoice Amount before TDS (Invoice Amount = Net Received + TDS)
                    var tdsAmountAbs = Math.abs(additionalTaxTotal);
                    var originalInvoiceTotalINR = netReceivedINR + tdsAmountAbs;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', fontSize: '12px' }}>
                            {/* Original Invoice Commission */}
                            <div style={{ fontSize: '13px', fontWeight: 700, color: '#262626' }}>
                                <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Invoice Comm:</span>
                                {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
                            </div>

                            {/* Total Invoice Amount before TDS (INR) */}
                            <div style={{ color: '#595959', fontWeight: 600, borderTop: '1px dashed #e8e8e8', paddingTop: '4px' }}>
                                <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Invoice Amt ({companyCurrency}):</span>
                                <span style={{ color: '#1890ff', fontSize: '13px' }}>{companySymbol}{originalInvoiceTotalINR.toFixed(2)}</span>
                            </div>

                            {/* Less: TDS (INR) */}
                            {tdsAmountAbs > 0 && (
                                <div style={{ fontSize: '11px', color: '#fa8c16', fontWeight: 500 }}>
                                    <span style={{ color: '#8c8c8c', marginRight: 6 }}>
                                        Less: {record.additionalTaxDetails && record.additionalTaxDetails[0] && record.additionalTaxDetails[0].taxName ? record.additionalTaxDetails[0].taxName : 'TDS'} ({companyCurrency}):
                                    </span>
                                    -{companySymbol}{tdsAmountAbs.toFixed(2)}
                                </div>
                            )}

                            {/* Less: Bank Charges (INR) */}
                            {bankChargesTotal > 0 && (
                                <div style={{ fontSize: '11px', color: '#f5222d', fontWeight: 500 }}>
                                    <span style={{ color: '#8c8c8c', marginRight: 6 }}>Less: Bank Charges ({companyCurrency}):</span>
                                    -{companySymbol}{bankChargesTotal.toFixed(2)}
                                </div>
                            )}

                            {/* Final Amount Credited / Received (INR) */}
                            <div style={{ fontSize: '12px', fontWeight: 700, color: '#389e0d', borderTop: '1px solid #f0f0f0', paddingTop: '3px' }}>
                                <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Amount Credited ({companyCurrency}):</span>
                                {companySymbol}{(netReceivedINR - bankChargesTotal).toFixed(2)}
                            </div>
                        </div>
                    );
                }
            },
            // {
            //     title: 'Financial Breakdown',
            //     key: 'financialBreakdown',
            //     width: 240,
            //     render: (text, record) => {
            //         var invoiceCurrency = record && record.invoices && record.invoices.length > 0 && record.invoices[0].currency ? record.invoices[0].currency : 'EUR';
            //         var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';
            //         var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

            //         var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

            //         // Direct mapping sum of single dynamic values from object
            //         var totalInvoiceGrossSumINR = 0;
            //         if (record && record.invoices) {
            //             totalInvoiceGrossSumINR = record.invoices.reduce((sum, item) => {
            //                 var studentGrossInINR = Number(item.grossPaymentReceived) || 0;
            //                 return sum + studentGrossInINR;
            //             }, 0);
            //         }

            //         var taxAmountTotal = 0;
            //         if (record && record.cpTaxDetails) {
            //             taxAmountTotal = record.cpTaxDetails.reduce((sum, item) => {
            //                 return sum + (item.totalCpTax || 0);
            //             }, 0);
            //         }

            //         return (
            //             <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            //                 <div style={{ fontSize: '14px', fontWeight: 700, color: '#262626' }}>
            //                     <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Invoice Comm:</span>
            //                     {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
            //                 </div>

            //                 <div style={{ fontSize: '12px', color: '#595959', fontWeight: 600, borderTop: '1px solid #f0f0f0', paddingTop: '4px' }}>
            //                     <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Total Gross ({companyCurrency}):</span>
            //                     <span style={{ color: '#1890ff', fontSize: '13px' }}>{companySymbol}{totalInvoiceGrossSumINR.toFixed(2)}</span>
            //                 </div>

            //                 {taxAmountTotal > 0 && (
            //                     <div style={{ fontSize: '11px', color: '#f5222d', fontWeight: 500 }}>
            //                         <span style={{ color: '#8c8c8c', marginRight: 6 }}>Tax ({companyCurrency}):</span>
            //                         {companySymbol}{Number(taxAmountTotal).toFixed(2)}
            //                     </div>
            //                 )}
            //             </div>
            //         );
            //     }
            // },
            {
                title: 'Invoice Status',
                key: 'invoiceStatus',
                width: 160,
                align: 'center',
                render: (text, record) => {
                    var status = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
                    var reqStatus = record && record.requestedInvoiceStatus ? record.requestedInvoiceStatus : null;

                    var reqUser = record && record.clearRequestAddedBy ? record.clearRequestAddedBy : null;
                    var reqByName = reqUser && reqUser.name ? reqUser.name : null;

                    var reqAtTime = '';
                    if (reqUser && reqUser.time) {
                        var rawTime = reqUser.time.$date ? reqUser.time.$date : reqUser.time;
                        reqAtTime = moment(rawTime).format('DD/MM/YY HH:mm');
                    }

                    var getBadgeStyles = function (currentStatus) {
                        var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
                        var config = {
                            'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
                            'APPROVED BY UNI': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                            'PAID BY UNI': { color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7' },
                            'TO BE INVOICED': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' },
                            'SUBMITTED TO UNI': { color: '#096dd9', bg: '#e6f7ff', border: '#91d5ff' }
                        };
                        return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
                    };

                    var mainStyles = getBadgeStyles(status);

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                            <span style={{
                                fontSize: '11px',
                                fontWeight: 700,
                                color: mainStyles.color,
                                background: mainStyles.bg,
                                border: '1px solid ' + mainStyles.border,
                                padding: '2px 8px',
                                borderRadius: '12px',
                                textTransform: 'uppercase'
                            }}>
                                {status}
                            </span>

                            {reqStatus && (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '2px' }}>
                                    <span style={{ fontSize: '10px', color: '#bfbfbf' }}>
                                        Req: <strong style={{ color: '#595959' }}>{reqStatus}</strong>
                                    </span>

                                    {reqByName && (
                                        <span style={{ fontSize: '10px', color: '#8c8c8c', marginTop: '1px' }}>
                                            by {reqByName}
                                        </span>
                                    )}

                                    {reqAtTime && (
                                        <span style={{ fontSize: '9px', color: '#bfbfbf', fontStyle: 'italic' }}>
                                            {reqAtTime}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                title: 'Company Details',
                key: 'companyDetails',
                width: 240,
                render: (text, record) => (
                    <div style={{
                        lineHeight: '22px',
                        padding: '10px',
                        background: '#fff',
                        border: '1px solid #f0f0f0',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.02)'
                    }}>
                        <div style={{ fontWeight: 700, fontSize: '14px', color: '#262626', marginBottom: '6px' }}>
                            <Icon type="global" style={{ marginRight: 6, color: '#fa8c16' }} />
                            {record.invoiceToName}
                        </div>
                        <div style={{ fontSize: '12px', color: '#595959' }}>
                            <div><b>CP:</b> {record.kindAttention}</div>
                            <div><b>Email:</b> {record.invoiceToEmail}</div>
                            <div><b>Phone:</b> {record.invoiceToPhone}</div>
                            <div style={{ marginTop: '4px' }}>
                                <span style={{
                                    background: '#f5f5f5',
                                    padding: '2px 6px',
                                    borderRadius: '4px',
                                    fontSize: '11px',
                                    border: '1px solid #d9d9d9',
                                    color: '#595959'
                                }}>
                                    {record.invoiceToCategory}
                                </span>
                            </div>
                        </div>
                    </div>
                )
            }
        ];
        // const columns = [
        //     {
        //         title: 'Actions',
        //         key: 'actions',
        //         width: 80,
        //         align: 'center',
        //         // ✅ Arrow function automatically catches component's 'this' context
        //         render: (text, record) => {
        //             return (
        //                 <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
        //                     <Button
        //                         loading={loading}
        //                         type="primary"
        //                         size="small"
        //                         icon="check"
        //                         shape="circle"
        //                         style={{ background: '#52c41a', borderColor: '#52c41a', fontSize: '12px' }}
        //                         onClick={() => this.handleInvoiceAction(record._id, 'Approve')}
        //                         title="Approve"
        //                     />
        //                     <Button
        //                         loading={loading}
        //                         type="danger"
        //                         size="small"
        //                         icon="close"
        //                         shape="circle"
        //                         style={{ fontSize: '12px' }}
        //                         onClick={() => this.handleInvoiceAction(record._id, 'Disapprove')}
        //                         title="Disapprove"
        //                     />
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: '#',
        //         key: 'serialNumber',
        //         width: 50,
        //         align: 'center',
        //         render: (text, record, index) => (
        //             <span style={{ fontWeight: 600, color: '#8c8c8c' }}>{index + 1}</span>
        //         )
        //     },
        //     {
        //         title: 'Invoice Details',
        //         key: 'invoiceDetails',
        //         width: 180,
        //         render: (text, record) => {
        //             var invNum = record && record.invoiceNumber ? record.invoiceNumber : '-';
        //             var invDate = record && record.invoiceGeneratedDate && record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : (record && record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : '-');

        //             var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;
        //             var receipts = record && record.paymentReceipt ? record.paymentReceipt : [];
        //             var singleReceiptUrl = receipts.length > 0 && receipts[0].url ? receipts[0].url : null;

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        //                     <span style={{ fontWeight: 700, color: '#262626', fontSize: '13px' }}>
        //                         {invUrl ? (
        //                             <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', textDecoration: 'underline' }}>
        //                                 {invNum}
        //                             </a>
        //                         ) : invNum}
        //                     </span>
        //                     <span style={{ fontSize: '11px', color: '#595959' }}>
        //                         <Icon type="calendar" style={{ marginRight: 4, color: '#bfbfbf' }} />
        //                         Gen: {invDate}
        //                     </span>

        //                     <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
        //                         {invUrl && (
        //                             <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#13c2c2' }}>
        //                                 <Icon type="file-pdf" style={{ marginRight: 2 }} /> View Invoice
        //                             </a>
        //                         )}
        //                         {singleReceiptUrl && (
        //                             <a href={`${MEDIA_URL}${singleReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#722ed1' }}>
        //                                 <Icon type="file-done" style={{ marginRight: 2 }} /> Receipt
        //                             </a>
        //                         )}
        //                     </div>
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Student & Course Details',
        //         key: 'studentCourseDetails',
        //         width: 320,
        //         render: (text, record) => {
        //             var students = record && record.invoices ? record.invoices : [];

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        //                     {students.map((item, idx) => {
        //                         var studentConversion = item.conversionRate ? item.conversionRate : '-';
        //                         var studentCurrency = item.currency ? item.currency : 'EUR';
        //                         var studentSymbol = currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';
        //                         var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

        //                         var itemComm = item.commissionTotal ? Number(item.commissionTotal) : 0;
        //                         var itemGrossConverted = item.grossPaymentReceived ? Number(item.grossPaymentReceived) : 0;

        //                         return (
        //                             <div key={idx} style={{
        //                                 padding: '8px 0',
        //                                 borderBottom: idx !== students.length - 1 ? '1px dashed #e8e8e8' : 'none'
        //                             }}>
        //                                 <div style={{ fontWeight: 700, color: '#141414', fontSize: '13px' }}>
        //                                     <Icon type="user" style={{ marginRight: 6, color: '#1890ff' }} />
        //                                     {item.studentName}
        //                                 </div>
        //                                 <div style={{ fontSize: '11px', color: '#595959', margin: '2px 0' }}>
        //                                     <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
        //                                     {item.universityInstitutionName || record.invoiceToName || '-'}
        //                                 </div>
        //                                 <div style={{ fontSize: '11px', color: '#8c8c8c', marginBottom: '4px' }}>
        //                                     {item.courseName}
        //                                 </div>

        //                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', background: '#fafafa', padding: '6px', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
        //                                     <span style={{ fontSize: '11px', color: '#434343' }}>
        //                                         <strong>Comm:</strong> {studentSymbol}{itemComm.toFixed(2)}
        //                                     </span>
        //                                     <span style={{ fontSize: '11px', color: '#434343' }}>
        //                                         <strong>Gross (Converted):</strong> {companySymbol}{itemGrossConverted.toFixed(2)}
        //                                     </span>
        //                                     <span style={{
        //                                         fontSize: '10px',
        //                                         marginTop: '2px',
        //                                         color: '#595959',
        //                                         display: 'inline-block'
        //                                     }}>
        //                                         <Icon type="swap" style={{ marginRight: 4, color: '#8c8c8c' }} />
        //                                         Exchange Rate: 1 {studentCurrency} = {studentConversion} {companyCurrency}
        //                                     </span>
        //                                 </div>
        //                             </div>
        //                         );
        //                     })}
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Financial Breakdown',
        //         key: 'financialBreakdown',
        //         width: 240,
        //         render: (text, record) => {
        //             var students = record && record.invoices ? record.invoices : [];

        //             var invoiceCurrency = record && record.currency ? record.currency : 'EUR';
        //             var invoiceSymbol = currencySymbols[invoiceCurrency] ? currencySymbols[invoiceCurrency] : invoiceCurrency + ' ';
        //             var companySymbol = currencySymbols[companyCurrency] ? currencySymbols[companyCurrency] : companyCurrency + ' ';

        //             var commissionGrandTotal = record && record.commissionGrandTotal ? record.commissionGrandTotal : 0;

        //             // Direct mapping sum of single dynamic values from object
        //             var totalInvoiceGrossSumINR = 0;
        //             if (record && record.invoices) {
        //                 totalInvoiceGrossSumINR = record.invoices.reduce((sum, item) => {
        //                     var studentGrossInINR = Number(item.grossPaymentReceived) || 0;
        //                     return sum + studentGrossInINR;
        //                 }, 0);
        //             }

        //             var taxAmountTotal = 0;
        //             if (record && record.cpTaxDetails) {
        //                 taxAmountTotal = record.cpTaxDetails.reduce((sum, item) => {
        //                     return sum + (item.totalCpTax || 0);
        //                 }, 0);
        //             }

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        //                     <div style={{ fontSize: '14px', fontWeight: 700, color: '#262626' }}>
        //                         <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Invoice Comm:</span>
        //                         {invoiceSymbol}{Number(commissionGrandTotal).toFixed(2)}
        //                     </div>

        //                     <div style={{ fontSize: '12px', color: '#595959', fontWeight: 600, borderTop: '1px solid #f0f0f0', paddingTop: '4px' }}>
        //                         <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Total Gross ({companyCurrency}):</span>
        //                         <span style={{ color: '#1890ff', fontSize: '13px' }}>{companySymbol}{totalInvoiceGrossSumINR.toFixed(2)}</span>
        //                     </div>

        //                     {taxAmountTotal > 0 && (
        //                         <div style={{ fontSize: '11px', color: '#f5222d', fontWeight: 500 }}>
        //                             <span style={{ color: '#8c8c8c', marginRight: 6 }}>Tax ({companyCurrency}):</span>
        //                             {companySymbol}{Number(taxAmountTotal).toFixed(2)}
        //                         </div>
        //                     )}
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Invoice Status',
        //         key: 'invoiceStatus',
        //         width: 160,
        //         align: 'center',
        //         render: (text, record) => {
        //             var status = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
        //             var reqStatus = record && record.requestedInvoiceStatus ? record.requestedInvoiceStatus : null;

        //             // Root model se clearRequestAddedBy ki details access kari hain
        //             var reqUser = record && record.clearRequestAddedBy ? record.clearRequestAddedBy : null;
        //             var reqByName = reqUser && reqUser.name ? reqUser.name : null;

        //             // Handle normal string date or MongoDB style nested $date object safely
        //             var reqAtTime = '';
        //             if (reqUser && reqUser.time) {
        //                 var rawTime = reqUser.time.$date ? reqUser.time.$date : reqUser.time;
        //                 reqAtTime = moment(rawTime).format('DD/MM/YY HH:mm');
        //             }

        //             var getBadgeStyles = function (currentStatus) {
        //                 var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
        //                 var config = {
        //                     'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
        //                     'APPROVED BY UNI': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
        //                     'PAID BY UNI': { color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7' },
        //                     'TO BE INVOICED': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' }
        //                 };
        //                 return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
        //             };

        //             var mainStyles = getBadgeStyles(status);

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
        //                     {/* Main Status Badge */}
        //                     <span style={{
        //                         fontSize: '11px',
        //                         fontWeight: 700,
        //                         color: mainStyles.color,
        //                         background: mainStyles.bg,
        //                         border: '1px solid ' + mainStyles.border,
        //                         padding: '2px 8px',
        //                         borderRadius: '12px',
        //                         textTransform: 'uppercase'
        //                     }}>
        //                         {status}
        //                     </span>

        //                     {/* Requested Status Block with User Name and Datetime Audit */}
        //                     {reqStatus && (
        //                         <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '2px' }}>
        //                             <span style={{ fontSize: '10px', color: '#bfbfbf' }}>
        //                                 Req: <strong style={{ color: '#595959' }}>{reqStatus}</strong>
        //                             </span>

        //                             {reqByName && (
        //                                 <span style={{ fontSize: '10px', color: '#8c8c8c', marginTop: '1px' }}>
        //                                     by {reqByName}
        //                                 </span>
        //                             )}

        //                             {reqAtTime && (
        //                                 <span style={{ fontSize: '9px', color: '#bfbfbf', fontStyle: 'italic' }}>
        //                                     {reqAtTime}
        //                                 </span>
        //                             )}
        //                         </div>
        //                     )}
        //                 </div>
        //             );
        //         }
        //     }
        // ];
        // const columns = [
        //     {
        //         title: '#',
        //         key: 'serialNumber',
        //         width: 50,
        //         align: 'center',
        //         render: (text, record, index) => (
        //             <span style={{ fontWeight: 600, color: '#8c8c8c' }}>{index + 1}</span>
        //         )
        //     },
        //     {
        //         title: 'Invoice Details',
        //         key: 'invoiceDetails',
        //         width: 180,
        //         render: (text, record) => {
        //             var invNum = record && record.invoiceNumber ? record.invoiceNumber : '-';
        //             var invDate = record && record.invoiceGeneratedDate ? moment(record.invoiceGeneratedDate).format(dateFormat) : '-';

        //             // Document Tracking URL definitions
        //             var invUrl = record && record.invoiceUrl ? record.invoiceUrl : null;
        //             var receipts = record && record.paymentReceipt ? record.paymentReceipt : [];
        //             var singleReceiptUrl = receipts.length > 0 && receipts[0].url ? receipts[0].url : null;

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        //                     <span style={{ fontWeight: 700, color: '#262626', fontSize: '13px' }}>
        //                         {invUrl ? (
        //                             <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', textDecoration: 'underline' }}>
        //                                 {invNum}
        //                             </a>
        //                         ) : invNum}
        //                     </span>
        //                     <span style={{ fontSize: '11px', color: '#595959' }}>
        //                         <Icon type="calendar" style={{ marginRight: 4, color: '#bfbfbf' }} />
        //                         Gen: {invDate}
        //                     </span>

        //                     {/* Next tab actions for files */}
        //                     <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
        //                         {invUrl && (
        //                             <a href={`${MEDIA_URL}${invUrl}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#13c2c2' }}>
        //                                 <Icon type="file-pdf" style={{ marginRight: 2 }} /> View Invoice
        //                             </a>
        //                         )}
        //                         {singleReceiptUrl && (
        //                             <a href={`${MEDIA_URL}${singleReceiptUrl}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '11px', color: '#722ed1' }}>
        //                                 <Icon type="file-done" style={{ marginRight: 2 }} /> Receipt
        //                             </a>
        //                         )}
        //                     </div>
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Student & Course Details',
        //         key: 'studentCourseDetails',
        //         width: 280,
        //         render: (text, record) => {
        //             var students = record && record.invoices ? record.invoices : [];

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        //                     {students.map(function (item, idx) {
        //                         var studentConversion = item.conversionRate ? item.conversionRate : '-';
        //                         var studentCurrency = item.currency ? item.currency : 'EUR';
        //                         var sym = typeof currencySymbols !== 'undefined' && currencySymbols[studentCurrency] ? currencySymbols[studentCurrency] : studentCurrency + ' ';

        //                         return (
        //                             <div key={idx} style={{
        //                                 padding: '6px 0',
        //                                 borderBottom: idx !== students.length - 1 ? '1px dashed #f0f0f0' : 'none'
        //                             }}>
        //                                 <div style={{ fontWeight: 700, color: '#141414', fontSize: '12px' }}>
        //                                     <Icon type="user" style={{ marginRight: 6, color: '#1890ff' }} />
        //                                     {item.studentName}
        //                                 </div>
        //                                 <div style={{ fontSize: '11px', color: '#595959', margin: '2px 0' }}>
        //                                     <Icon type="bank" style={{ marginRight: 6, color: '#bfbfbf' }} />
        //                                     {item.universityInstitutionName || record.invoiceToName || '-'}
        //                                 </div>
        //                                 <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
        //                                     {item.courseName}
        //                                 </div>
        //                                 {/* Per-student dynamic conversion rendering configuration */}
        //                                 <div style={{ marginTop: '2px' }}>
        //                                     <span style={{
        //                                         fontSize: '10px',
        //                                         background: '#f5f5f5',
        //                                         padding: '1px 5px',
        //                                         borderRadius: '4px',
        //                                         color: '#595959',
        //                                         border: '1px solid #e8e8e8'
        //                                     }}>
        //                                         Exchange Rate: 1 {studentCurrency} = {studentConversion} INR
        //                                     </span>
        //                                 </div>
        //                             </div>
        //                         );
        //                     })}
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Financial Breakdown',
        //         key: 'financialBreakdown',
        //         width: 220,
        //         render: (text, record) => {
        //             var students = record && record.invoices ? record.invoices : [];

        //             // Normalized tracking according to specific target corporate configs
        //             var baseCompanyCurrency = record.currency ? record.currency : 'EUR';
        //             var companySymbol = typeof currencySymbols !== 'undefined' && currencySymbols[baseCompanyCurrency] ? currencySymbols[baseCompanyCurrency] : baseCompanyCurrency + ' ';

        //             var grossPaymentTotal = 0;
        //             if (record.invoices) {
        //                 grossPaymentTotal = record.invoices.reduce(function (sum, item) {
        //                     return sum + (item.grossPaymentReceived || 0);
        //                 }, 0);
        //             }

        //             var commissionGrandTotal = record.commissionGrandTotal ? record.commissionGrandTotal : 0;

        //             var taxAmountTotal = 0;
        //             if (record.cpTaxDetails) {
        //                 taxAmountTotal = record.cpTaxDetails.reduce(function (sum, item) {
        //                     return sum + (item.totalCpTax || 0);
        //                 }, 0);
        //             }

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        //                     <div style={{ fontSize: '14px', fontWeight: 700, color: '#262626' }}>
        //                         <span style={{ fontSize: '11px', color: '#8c8c8c', fontWeight: 500, marginRight: 6 }}>Comm:</span>
        //                         {companySymbol}{Number(commissionGrandTotal).toFixed(2)}
        //                     </div>

        //                     {/* Per-item dynamic multi-student item block metrics */}
        //                     <div style={{ fontSize: '12px', color: '#595959', fontWeight: 500 }}>
        //                         <span style={{ fontSize: '11px', color: '#bfbfbf', marginRight: 6 }}>Gross ({baseCompanyCurrency}):</span>
        //                         {companySymbol}{Number(grossPaymentTotal).toFixed(2)}
        //                     </div>

        //                     {taxAmountTotal > 0 && (
        //                         <div style={{ fontSize: '11px', color: '#f5222d', fontWeight: 500 }}>
        //                             <span style={{ color: '#bfbfbf', marginRight: 6 }}>Tax (IGST):</span>
        //                             {companySymbol}{Number(taxAmountTotal).toFixed(2)}
        //                         </div>
        //                     )}
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Invoice Status',
        //         key: 'invoiceStatus',
        //         width: 150,
        //         align: 'center',
        //         render: (text, record) => {
        //             var status = record && record.invoiceStatus ? record.invoiceStatus : 'PENDING';
        //             var reqStatus = record && record.requestedInvoiceStatus ? record.requestedInvoiceStatus : null;

        //             var getBadgeStyles = function (currentStatus) {
        //                 var s = currentStatus ? currentStatus.toUpperCase() : 'PENDING';
        //                 var config = {
        //                     'PENDING': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
        //                     'APPROVED BY UNI': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
        //                     'PAID BY UNI': { color: '#722ed1', bg: '#f9f0ff', border: '#d3adf7' },
        //                     'TO BE INVOICED': { color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' }
        //                 };
        //                 return config[s] || { color: '#595959', bg: '#f5f5f5', border: '#d9d9d9' };
        //             };

        //             var mainStyles = getBadgeStyles(status);

        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
        //                     <span style={{
        //                         fontSize: '11px',
        //                         fontWeight: 700,
        //                         color: mainStyles.color,
        //                         background: mainStyles.bg,
        //                         border: '1px solid ' + mainStyles.border,
        //                         padding: '2px 8px',
        //                         borderRadius: '12px',
        //                         textTransform: 'uppercase'
        //                     }}>
        //                         {status}
        //                     </span>
        //                     {reqStatus && (
        //                         <span style={{ fontSize: '10px', color: '#bfbfbf', marginTop: '2px' }}>
        //                             Req: <strong style={{ color: '#595959' }}>{reqStatus}</strong>
        //                         </span>
        //                     )}
        //                 </div>
        //             );
        //         }
        //     },
        //     {
        //         title: 'Actions',
        //         key: 'actions',
        //         width: 160,
        //         align: 'center',
        //         render: (text, record) => {
        //             return (
        //                 <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', alignItems: 'center' }}>
        //                     <Button
        //                         type="primary"
        //                         size="small"
        //                         icon="check"
        //                         style={{ background: '#52c41a', borderColor: '#52c41a', fontSize: '11px', width: '105px' }}
        //                         onClick={function () { this.handleInvoiceAction(record._id, 'Approve'); }.bind(this)}
        //                     >
        //                         Approve
        //                     </Button>
        //                     <Button
        //                         type="danger"
        //                         size="small"
        //                         icon="close"
        //                         style={{ fontSize: '11px', width: '105px' }}
        //                         onClick={function () { this.handleInvoiceAction(record._id, 'Disapprove'); }.bind(this)}
        //                     >
        //                         Disapprove
        //                     </Button>
        //                 </div>
        //             );
        //         }
        //     }
        // ];
        return (
            <Drawer
                title={`Invoice Status Update Requests:- ${count}`}
                placement="right"
                width={1000}
                closable={true}
                onClose={this.onClose}
                visible={visible}
            >
                <Card bordered={true}>
                    <Alert
                        message="Invoice Clearance Verification Process"
                        description={
                            <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                                <li><strong>Verify Clearance Details:</strong> Please check all transaction info and confirm with bank account records that the invoice amount has been successfully cleared from the University or CP.</li>
                                <li><strong>Automated Sub-Agent/Branch Notifications:</strong> Upon hitting approve, if the cleared invoice belongs to a student under a specific branch or sub-agent, the system will automatically dispatch a notification to inform them that their student commission has been received.</li>
                            </ul>
                        }
                        type="info"
                        showIcon
                        style={{ marginBottom: '20px' }}
                    />
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1200 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 200,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}



export default UpdateInvoiceStatusRequest;